<template>
<loader v-bind="{ loading }">
    <columns>
      <column>
        <form>
          <text-input v-model="filters.search" classes="is-rounded">
            <template #right>
              <div class="buttons has-addons is-rounded">
                <submit-button @click="runFilters" class="is-rounded">
                  <icon icon="search"/>
                  <span>Search</span>
                </submit-button>
              </div>
            </template>
          </text-input>
        </form>
      </column>
      <column class="is-narrow is-flex align-end">
        <router-link 
          :to="{
            name: 'create-checkpoint'
          }"
          class="is-small button is-rounded">
          <icon icon="plus" />
          <span>Checkpoint</span>
        </router-link>
      </column>
    </columns>

    <div>
      <div class="table-container">
        <table class="table is-fullwidth is-hoverable">
          <thead>
            <tr>
              <th>Checkpoint</th>
              <th>CWE</th>
              <th>Assesor</th>
              <th class="is-narrow">Standards</th>
              <th class="is-narrow">Risk</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="checkpoint in checkpoints.data" :key="checkpoint.id">
              <td>
                <router-link :to="{
                  name: 'checkpoint-manager',
                  params: {
                    checkpoint: checkpoint.id
                  }
                }">
                  {{ checkpoint.value }}
                </router-link>
              </td>
              <td>
                <span class="no-wrap">CWE-{{ checkpoint.cwe.number }}</span>
              </td>
              <td class="has-text-right">
                <yes-no :value="Boolean(checkpoint.assessor)"/>
              </td>
              <td class="has-text-right">
                {{ checkpoint.sections_count || 0 }}
              </td>
              <td class="has-text-right">
                {{ checkpoint.risk_level }}
              </td>
            </tr>
          </tbody>
        </table>
        <pager :pageable="checkpoints" jump-controls @nav="goToPage"/>
      </div>
    </div>
</loader>
</template>

<script>
import { getPath } from '@/api/common'
import Paginator from '@/store/models/Paginator'

export default {

  name: 'Checkpoints',

  data: () => ({
    checkpoints: new Paginator,
    loading: false,
    filters: {
      search: ''
    }
  }),

  created() {
    if(this.$route.query.search) {
      this.filters.search = this.$route.query.search;
    }
    this.loadCheckpoints()
  },

  methods: {
    loadCheckpoints() {
      getPath({ path: 'api/super' + this.$route.fullPath }, ({data}) => {
        this.checkpoints = data
        this.loading = false
      }, () => {})
    },
    runFilters() {
      this.$router.push({
        name: 'checkpoints',
        query: this.filters
      })
    },
    clearFilters() {
      this.filters.search = ''
      this.$router.push({
        name: 'checkpoints',
        query: this.filters
      })
    },
    goToPage(page) {
      this.$router.push(page)
    }
  },

  watch: {
    '$route': 'loadCheckpoints'
  }

}
</script>
